/**
 * components.js
 *
 * Import the JS for your components here.
 *
 */
import './Accordion/Accordion';
import './BackToTop/BackToTop';
import './SocialShare/SocialShare';
import './Buttons/stopDisabledLinksFiring';
import './Tables/TableWrapper';
import './Modal/Modal';
import './Slider/Slider';
import './AlgoliaPagination/AlgoliaPagination';
import ComponentInit from '../js/utils/ComponentInit';
import VideoEmbed from './VideoEmbed/VideoEmbed';
import './HeroBannerText/HeroBannerText';
import './PropertyHeroBanner/PropertyHeroBanner';
import './HeaderSearch/HeaderSearch';
import './PropertyCard/PropertySaleCardCarousel';
import './PropertyForSaleContact/PropertyForSaleContact';
import './MultistepModalCta/MultistepModalCta';
import './LandingPageMultistepModal/LandingPageMultiStepModal';

// Format:
// data-component-name: ComponentFunction
// we shall order these in page load critical first
const componentList = { VideoEmbed };

export default ComponentInit(componentList);
